module.exports = __webpack_public_path__ + "static/media/company2@3x.c616ded7.png";